import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { api } from '../../../../services';
import GeofenceForm from './GeofenceForm';

import './GeofenceDetail.css';

@withRouter
@inject('geofencesStore', 'translationsStore', 'commonStore')
@observer
export default class GeofenceDetail extends Component {
  constructor(props) {
    super(props);
	
    this.state = {
        loading: false,
        geofenceId: null,
        geofence: { schedules: [], vehicles: []},
      };
  }

  loadGeofenceDetail() {
    if (this.props.match.params.geofenceId > 0) {
      api('getGeofence', this.props.match.params.geofenceId)
      .then(geofence => {
        this.setState({ geofenceId: this.props.match.params.geofenceId, geofence: geofence, loading: false });
      })
      .catch(error => ({ error }));
    } else {
      let defaultGeofence = { status: "DISABLED", schedules: [], vehicles: [] };
      this.setState({ geofenceId: this.props.match.params.geofenceId, geofence: defaultGeofence, loading: false });
    }
  }

  componentDidMount() {
    this.loadGeofenceDetail();
  }

  render() {
        return (
          <div className="GeofenceDetail">
            <GeofenceForm geofenceId={this.props.match.params.geofenceId} geofence={this.state.geofence}/>
          </div>
        );
      }
    }
    


// WEBPACK FOOTER //
// ./src/components/App/Geofence/GeofenceDetail/GeofenceDetail.js